export const comments_3899728 = {"data":{"data":[],"links":{}}}